import { SkillConfigurationRemoteDto } from 'src/generated/signalR/skill-configuration-remote-dto';
import { State, StateContext, Action, Selector } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { OutBoundSkillShortInfoChanged } from './samwin-outbound-skill-shortinfo.actions';
import { QueueShortInfoRemoteDto, QueueShortInfoListResponseData } from 'src/generated/swagger';
import _ from 'lodash';

export interface SamwinOutBoundSkillShortInfoStateModel {
   skills: QueueShortInfoRemoteDto[];
}

@State<SamwinOutBoundSkillShortInfoStateModel>({
   name: 'samwinOutboundSkillShortInfo',
   defaults: {
      skills: [],
   },
})
@Injectable()
export class SamwinOutboundSkillShortInfoState {
   constructor() {}

   @Selector([SamwinOutboundSkillShortInfoState])
   public static getSkillCount(state: SamwinOutBoundSkillShortInfoStateModel): number {
      if (_.isNil(state.skills)) {
         return 0;
      }
      return state.skills.length;
   }

   @Selector([SamwinOutboundSkillShortInfoState])
   public static getSingleSkillId(state: SamwinOutBoundSkillShortInfoStateModel): number {
      if (_.isNil(state.skills)) {
         return 0;
      }
      return state.skills[0].id;
   }

   @Selector([SamwinOutboundSkillShortInfoState])
   public static getSkills(state: SamwinOutBoundSkillShortInfoStateModel): QueueShortInfoRemoteDto[] {
      if (_.isNil(state.skills)) {
         return null;
      }
      return state.skills;
   }

   @Action(OutBoundSkillShortInfoChanged)
   public outBoundSkillShortInfoChange(ctx: StateContext<SamwinOutBoundSkillShortInfoStateModel>, action: OutBoundSkillShortInfoChanged) {
      ctx.patchState({
         skills: action.outBoundSkillShortInfo,
      });
   }
}
